import PdfDialog from "../../../../commons/file/PdfDialog";

const ViewDialog = ({ open, title, file, onClose }) => {

  return (
    <>
      {open && (
        <div>
          <PdfDialog
            open={open}
            title={title}
            handleClose={onClose}
            controllers={true}
            file={file}
            printTitle={title}
            printable
            acceptButton={false}
            closeButton
          />
        </div>
      )}
    </>
  );
};

export default ViewDialog;
